import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
var _withScopeId = function (n) {
  return _pushScopeId("data-v-67fc5ea0"), n = n(), _popScopeId(), n;
};
var _hoisted_1 = {
  class: "wrapper-container"
};
var _hoisted_2 = /*#__PURE__*/_withScopeId(function () {
  /*#__PURE__*/return _createElementVNode("div", {
    class: "desc"
  }, "正在检测，请勿关闭当前页面", -1);
});
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  var _component_MicroVideo = _resolveComponent("MicroVideo");
  var _component_MicroPhone = _resolveComponent("MicroPhone");
  var _component_Countdown = _resolveComponent("Countdown");
  return _openBlock(), _createElementBlock("div", _hoisted_1, [_createVNode(_component_MicroVideo, {
    stream: _ctx.mediaService.stream
  }, null, 8, ["stream"]), _createVNode(_component_MicroPhone, {
    ready: _ctx.ready
  }, null, 8, ["ready"]), _createVNode(_component_Countdown, {
    time: _ctx.countdownService.current
  }, null, 8, ["time"]), _hoisted_2]);
}